import { useScrollAnimation } from '../../hooks/useScrollAnimation';

export const VideoSection = () => {
  const [ref, isVisible] = useScrollAnimation(0.1);

  return (
    <section className="bg-[#0A0A0A] py-20 lg:py-28 border-t border-white/[0.03]">
      <div
        ref={ref}
        className={`max-w-[1600px] mx-auto px-6 lg:px-16 transition-all duration-700 ${
          isVisible
            ? 'opacity-100 translate-y-0'
            : 'opacity-0 translate-y-10'
        }`}
      >
        <div className="mb-10">
          <p className="text-[#C4A265] tracking-[0.4em] uppercase text-[11px] mb-3">
            In Motion
          </p>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-[3.5rem] text-[#F5F1EC] leading-[1.05]">
            <span className="font-light">See Our</span>{' '}
            <span className="italic">Craft</span>
          </h2>
        </div>

        <div className="relative w-full aspect-video overflow-hidden bg-[#111]">
          <iframe
            src="https://www.youtube.com/embed/7qTFEcmc1KY?rel=0&modestbranding=1&color=white"
            title="All The Details — Steel Windows & Doors"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
            className="absolute inset-0 w-full h-full border-0"
          />
        </div>
      </div>
    </section>
  );
};
